import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ReportSubscription, ReportSubscriptionCreate, ReportSubscriptionFilter } from '../data/reportSubscription';

export function createReportSubscriptionService(client: AxiosInstance) {
  return createCrudService<ReportSubscription, ReportSubscriptionCreate, ReportSubscriptionFilter>(
    client,
    '/reporting/ReportSubscription',
    'id',
  );
}

export type ReportSubscriptionService = CrudService<ReportSubscription, ReportSubscriptionCreate, ReportSubscriptionFilter>;
